__turbopack_context__.v({
  "desktopVisible": "NavAccordion-module-scss-module__172vGG__desktopVisible",
  "icon": "NavAccordion-module-scss-module__172vGG__icon",
  "icon_open": "NavAccordion-module-scss-module__172vGG__icon_open",
  "items": "NavAccordion-module-scss-module__172vGG__items",
  "navAccordion": "NavAccordion-module-scss-module__172vGG__navAccordion",
  "slideDown": "NavAccordion-module-scss-module__172vGG__slideDown",
  "summary": "NavAccordion-module-scss-module__172vGG__summary",
  "title": "NavAccordion-module-scss-module__172vGG__title",
});
